import { deepEqual } from 'Helpers/deepEqual';

export default {
    data() {
        return {
            tmpValue: [],
            options: [],
            loading: false,
        };
    },
    created() {
        if (this.value.length > 0) {
            this.tmpValue = this.value.map((val) => val.numericValue);
            _.map(this.value, (val) => {
                if (val.autocompleteValue) {
                    this.options.push(val.autocompleteValue);
                }
            });
        }
    },
    computed: {},
    methods: {
        remove(removed) {
            const checkAlreadayInValue =
                this.value.length > 0
                    ? this.value.find((val) => val.numericValue == removed)
                    : false;
            if (checkAlreadayInValue) {
                this.$emit('remove', checkAlreadayInValue);
            } else {
                const buildData = JSON.parse(JSON.stringify(this.templateData));
                buildData.numericValue = removed;
                this.$emit('remove', buildData);
            }
        },
        formatAndEmit(values) {
            if (values.length > 0) {
                values.map((value) => {
                    const checkAlreadayInValue =
                        this.value.length > 0
                            ? this.value.find((val) => val.numericValue == value)
                            : false;
                    if (checkAlreadayInValue) {
                        checkAlreadayInValue.autocompleteValue = this.options.find(
                            (option) => option.id == value,
                        );
                        this.$emit('update:modelValue', checkAlreadayInValue);
                    } else {
                        const buildData = JSON.parse(JSON.stringify(this.templateData));
                        buildData.numericValue = value;
                        buildData.autocompleteValue = this.options.find(
                            (option) => option.id == value,
                        );
                        this.$emit('update:modelValue', buildData);
                    }
                });
            }
        },
    },
    watch: {
        tmpValue(newValue, oldValue) {
            if (!deepEqual(newValue, oldValue)) {
                if (newValue.length != oldValue.length) {
                    const valid = this.checkParams(newValue);
                    if (!valid) {
                        if (!this.reference || this.$refs) return;
                        this.$refs[this.reference].blur();
                        this.$emit('error', {
                            name: this.reference,
                            message: this.$l10n.__('Limite atteinte'),
                        });
                    } else {
                        if (newValue.length < oldValue.length) {
                            this.remove(oldValue.filter((value) => !newValue.includes(value)));
                        }
                        if (newValue.length > 0) {
                            this.formatAndEmit(newValue);
                        }
                    }
                }
            }
        },
        value: {
            handler: function (newValue, oldValue) {
                if (!deepEqual(newValue, oldValue)) {
                    this.tmpValue = newValue.map((val) => val.numericValue);
                    this.options = [];
                    newValue.map((val) => {
                        if (val.autocompleteValue) {
                            this.options.push(val.autocompleteValue);
                        }
                    });
                }
            },
            deep: true,
        },
    },
};
